import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

// Bento grid layout classes — 10 tiles with varied aspect ratios
const SPANS = [
  "md:col-span-5 md:row-span-2 aspect-[4/5]",
  "md:col-span-4 aspect-[5/4]",
  "md:col-span-3 aspect-[5/4]",
  "md:col-span-3 aspect-[4/5]",
  "md:col-span-4 aspect-[4/3]",
  "md:col-span-7 aspect-[5/3]",
  "md:col-span-5 aspect-[5/4]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-3 aspect-[4/5]",
  "md:col-span-12 aspect-[16/7]",
];

export const Lookbook = () => {
  const [tiles, setTiles] = useState([]);

  useEffect(() => {
    api
      .get("/products")
      .then((r) => {
        const all = r.data || [];
        // Deduplicate by image URL, keep first N unique
        const seen = new Set();
        const picks = [];
        for (const p of all) {
          if (!p.image_url || seen.has(p.image_url)) continue;
          seen.add(p.image_url);
          picks.push({ url: p.image_url, label: p.name });
          if (picks.length >= 10) break;
        }
        setTiles(picks);
      })
      .catch(() => setTiles([]));
  }, []);

  if (tiles.length === 0) return null;

  return (
    <section
      data-testid="lookbook-section"
      className="border-y border-[#2D2622]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="flex items-end justify-between mb-14 md:mb-20 gap-6">
          <div>
            <p className="text-[11px] tracking-overline uppercase font-bold text-[#D4AF37] mb-4">
              № 03 — The lookbook
            </p>
            <h2 className="font-serif-display font-light text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight text-[#F4EAD9]">
              Bottles, <span className="italic text-[#D4AF37]">light</span> and moods.
            </h2>
          </div>
          <p className="hidden md:block max-w-xs text-sm text-[#B0A496] leading-relaxed">
            A visual diary from the atelier — photographed slowly, in natural light,
            with no retouching.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4">
          {tiles.map((im, idx) => (
            <Link
              key={idx}
              to="/shop"
              data-testid={`lookbook-tile-${idx}`}
              className={`relative image-zoom-parent overflow-hidden group bg-[#1F1A17] ${SPANS[idx % SPANS.length]}`}
            >
              <img
                src={im.url}
                alt={im.label}
                loading="lazy"
                className="image-zoom absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <p className="absolute bottom-3 left-4 right-4 text-[10px] tracking-overline uppercase font-bold text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {im.label}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Lookbook;
